import { render, staticRenderFns } from "./REMSCoursePanel.vue?vue&type=template&id=b1397f0a"
import script from "./REMSCoursePanel.vue?vue&type=script&lang=js"
export * from "./REMSCoursePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports